export default "__VITE_ASSET__gKCdp$cJ__"